import { render } from "./RoomType.vue?vue&type=template&id=2cf5bcc4&scoped=true"
import script from "./RoomType.vue?vue&type=script&lang=js"
export * from "./RoomType.vue?vue&type=script&lang=js"

import "./RoomType.vue?vue&type=style&index=0&id=2cf5bcc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf5bcc4"]])

export default __exports__